/**
 * Created by andrey on 18.05.2026
 *
 * Timeouts works only on an active platform
 */

class ConnectorTimeouts {
    constructor() {
        this.uid = 1;
        this.listeners = Object.create(null);

        this.pauseTime = 0;
        this.tickTime = 0;

        connector.platform.on("pause", () => this.updateTickInterval());
        connector.platform.on("resume", () => this.updateTickInterval());

        this.updateTickInterval();
    }

    updateTickInterval() {
        const paused = connector.platform.isPaused;

        if (paused) {
            if (this.tickInterval !== undefined) {
                clearInterval(this.tickInterval);
                this.tickInterval = undefined;
            }

            this.pauseTime = performance.now();
            return;
        }

        if (this.tickInterval !== undefined) {
            return;
        }

        if (this.tickTime < this.pauseTime) {
            this.onTick(this.pauseTime - this.tickTime);
        }

        this.tickTime = performance.now();

        this.tickInterval = setInterval(() => {
            const now = performance.now();

            this.onTick(now - this.tickTime);

            this.tickTime = now;
        }, ConnectorTimeouts.INTERVAL);
    }

    onTick(dt) {
        for (const uid in this.listeners) {
            const listener = this.listeners[uid];
            if (!listener) {
                delete this.listeners[uid];
                continue;
            }

            listener.timeLeft -= dt;

            if (listener.timeLeft <= 0) {
                if (listener.interval === undefined) {
                    delete this.listeners[uid];
                } else {
                    listener.timeLeft = listener.interval;
                }

                try {
                    listener.callback();
                } catch (e) {
                    connector.utils.throwAsync(e, e);
                }
            }
        }
    }

    setTimeout(callback, ms, options) {
        const timeout = {
            uid: this.uid,
            callback,
            timeLeft: ms || 0
        };

        if (options && options.interval) {
            timeout.interval = ms || 0;
        }

        this.listeners[this.uid] = timeout;
        this.uid += 1;
        return timeout;
    }

    setInterval(callback, ms) {
        return this.setTimeout(callback, ms, { interval: true });
    }

    clearTimeout(timeout) {
        if (timeout && timeout.uid) {
            delete this.listeners[timeout.uid];
        }
    }

    clearInterval(timeout) {
        this.clearTimeout(timeout);
    }
}

ConnectorTimeouts.INTERVAL = 1000;